// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609170952/js/" + chunkId + "." + {"44":"b3160f52","225":"57b9dbe0","481":"667f2266","486":"e7675057","770":"87819d5f"}[chunkId] + ".0.30386299455810384.chunk.js";
};